import { LogicalOperator } from '@/studbook/constants';
import { FormDto } from './generated-core-api-types';
import {
  EntityDetailOption,
  EntityDetailType,
  EntityDto,
  PedigreeNodeDto,
} from '@/apiClient';

export interface GetOptInOrgsResponse {
  optInOrganisations: {
    orgId: string;
    name: string;
    description: string;
  }[];
}

export interface EntityDetailValue {
  entityDetailValueId: number;
  entityId: number;
  entityDetailId: number;
  value: string;
  organisationId?: number;
  entityDetailName: string;
  entityDetailType: number;
  additionalInfo?: {
    entityId: string;
    id: number;
    ident: string;
    name: string;
  };
}

export interface Entity {
  entityDetailEnhancers: EntityDetailEnhancer[];
  entityId: number;
  entityGuid: string;
  entityTypeCode: number;
  entityDetailValues: EntityDetailValue[];
}

export interface AnimalEntity extends Entity {
  breeder?: Entity;
  pedigree: PedigreeNodeDto;
  progeny: PagedEntityResponse<Entity>;
}

export interface PagedEntityResponse<T> {
  pageSize: number;
  pageCount: number;
  rowCount: number;
  currentPage: number;
  results: T[];
}

export interface GetAnimalsResponse {
  animals: PagedEntityResponse<Entity>;
}

export interface GetAnimalResponse {
  animal: AnimalEntity;
}

export interface GetAnimalDetailsResponse {
  animalDetails: {
    entityDetailId: number;
    entityDetailName: string;
    isDatabaseSearchEnable: boolean;
    entityDetailConfigs: QueryDetailConfig;
  }[];
}

export interface GetMemberDetailsResponse {
  memberDetails: {
    entityDetailId: number;
    entityDetailName: string;
    isDatabaseSearchEnable: boolean;
    entityDetailConfigs: QueryDetailConfig;
  }[];
}

export type EntityDetailEnhancer = {
  name: string;
  value: string;
};

export type EntityDetailEnhancers = [
  {
    name: 'Animal Display Name';
    value: string;
  },
];

export interface AnimalDetailOption {
  label: string;
  value: string;
}

export interface QueryDetailConfig {
  labelText: string;
  detailName: string;
  detailTypeValue: EntityDetailType;
  options: EntityDetailOption[];
}

export interface GetFormResponse {
  form: FormDto;
}

export interface GetMembersResponse {
  members: PagedEntityResponse<Entity>;
}

export enum SortDirection {
  Ascending = 0,
  Descending = 1,
}

export interface Role {
  roleId: number;
  userId: number;
  organisationId: number;
  organisation: Organisation;
  roleDetail: RoleDetail;
}

export interface RoleDetail {
  roleId: number;
  roleEntityId: string;
  roleName: string;
  roleDescription: string;
  isSystemRole: boolean;
  isDefaultRole: boolean;
}

export interface GetOrganisationResponse {
  organisation: Organisation;
}

export interface Organisation {
  organisationId: number;
  organisationEntityId: string;
  name: string;
  description: string;
  currency: string;
  country: string;
  isFreeMembership: boolean;
  constitutionUrl: string;
  prefixSettings: {
    value: string;
    requiredByDefault: boolean;
  }[];
}

export interface EntityDetailFilterInput {
  detailName: string;
  value: string;
  operator: number;
  logicalOperator: LogicalOperator;
}

export interface GetMemberFormResponse {
  memberForm: {
    entity: EntityDto;
    form: string;
  };
}

export type TIdentTypeCategory = 'types' | 'societies' | 'countries';
export type TAlternateIdentOption = {
  label: string;
  category: TIdentTypeCategory;
  value: string;
};
